import { render, staticRenderFns } from "./TempQuotation.vue?vue&type=template&id=720352f2"
import script from "./TempQuotation.vue?vue&type=script&lang=js"
export * from "./TempQuotation.vue?vue&type=script&lang=js"
import style0 from "./TempQuotation.vue?vue&type=style&index=0&id=720352f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports